<template>
  <v-card>
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ formTitle }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md fluid wrap>
        <v-layout wrap>
          <v-flex xs12 sm3 md6>
            <service-type-list-select
              :supplier-type="supplierType"
              :service-type-name="service.typeName"
              @onSelect="onServiceTypeSelect($event)"
              :outlined="outlinedInputs"
            ></service-type-list-select>
          </v-flex>
          <v-flex xs12 sm3 md6>
            <v-text-field
              label="Service Code"
              v-model="service.code"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm3 md6>
            <v-text-field
              label="Service Name"
              placeholder="New Service"
              v-model="service.name"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm3 md6>
            <v-text-field
              label="Alternative Name"
              v-model="service.altName"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm3 md4 pb-0>
            <v-text-field
              label="Service Min Occupancy"
              v-model="service.minOccupancy"
              map="#"
              :outlined="outlinedInputs"
              type="number"
              :max="service.maxOccupancy"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md4 pb-0>
            <v-text-field
              label="Service Std Occupancy"
              v-model="service.stdOccupancy"
              map="#"
              :outlined="outlinedInputs"
              type="number"
              :max="service.maxOccupancy"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md4 pb-0>
            <v-text-field
              label="Service Max Occupancy"
              v-model="service.maxOccupancy"
              map="#"
              :outlined="outlinedInputs"
              type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout py-0>
          <v-flex py-0>
            <v-switch v-model="service.notInUse" label="Not in use"></v-switch>
          </v-flex>
          <v-flex py-0>
            <v-switch v-model="service.noReport" label="No report"></v-switch>
          </v-flex>
          <v-flex py-0>
            <v-switch v-model="service.noVoucher" label="No voucher"></v-switch>
          </v-flex>
          <v-flex
            py-0
            v-if="$store.getters.hasAccessTo('third_party:marketplace')"
          >
            <v-switch
              v-model="service.marketPlace"
              label="Market Place"
            ></v-switch>
          </v-flex>
        </v-layout>
        <v-layout py-0>
          <v-flex py-0>
            <v-switch
              v-model="service.skipMarkup"
              label="Skip Markup"
            ></v-switch>
          </v-flex>
          <v-flex py-0>
            <v-switch
              v-model="service.skipCircuitDiscount"
              label="Skip Circuit Discount"
            ></v-switch>
          </v-flex>
          <v-flex py-0>
            <v-switch
              v-model="service.skipAgentCommission"
              label="Skip Agent Commission"
            ></v-switch>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col sm="6" class="pb-0">
            <taxes-list-select
              :outlined="outlinedInputs"
              v-model="taxType"
              hide-details
              @onSelectTaxType="onTaxSelect"
            ></taxes-list-select>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col>
            <code>
              {{ taxType }}
            </code>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="grey lighten-3">
      <v-spacer></v-spacer>
      <v-btn text color="warning" @click="$emit('onCancel')">Cancel</v-btn>
      <v-btn
        text
        color="secondary"
        @click="$emit('onSave', service)"
        :disabled="!isValid"
        >Save & Next</v-btn
      >
      <v-btn
        color="primary"
        @click="$emit('onCloseAndSave', service)"
        :disabled="!isValid"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import ServiceTypeListSelect from "../../shared/ServiceTypeListSelect";
import TaxesListSelect from "../../shared/TaxesListSelect.vue";
export default {
  name: "ServiceListItemForm",

  props: {
    service: { type: Object },
    supplierType: { type: String },
  },

  components: {
    ServiceTypeListSelect,
    TaxesListSelect,
  },

  data() {
    return {
      debug: false,
      serviceTypes: {},
      taxType: this.service ? this.service.taxCode : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    formTitle() {
      return this.service ? this.service.name : "Service Edit";
    },
    isValid() {
      return (
        this.service.name &&
        //this.service.code && Service codes should not be mandatory in vue. - Christina 17/04/2024
        this.service.typeName &&
        Number(this.service.minOccupancy) <=
          Number(this.service.maxOccupancy) &&
        Number(this.service.stdOccupancy) <= Number(this.service.maxOccupancy)
      );
    },
  },

  watch: {
    service(newVal) {
      this.taxType = newVal ? newVal.taxCode : "";
    },
  },

  methods: {
    onTaxSelect(payload) {
      this.taxType = payload.code;
      this.service.taxCode = this.taxType;
    },
    onServiceTypeSelect($event) {
      if (this.service.name === "") {
        //http://tracker.globetrack.ie/issues/5769
        this.service.name = $event.name;
      }
      this.service.typeName = $event.name;
      this.service.code = $event.code;
      this.service.minOccupancy = $event.minOccupancy;
      this.service.stdOccupancy = $event.stdOccupancy;
      this.service.maxOccupancy = $event.maxOccupancy;
      //https://tracker.globetrack.ie/issues/10157
      this.service.noReport = $event.hidden;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/ServiceListItemForm.vue